export enum RoutePath {
  BECOME_CUSTOMER_COMMON_PAGE = '/bli-kunde',
  // change bank
  CHANGE_BANK = '/bankbytte',
  CHANGE_BANK_BECOME_CUSTOMER = '/bankbytte/bli-kunde',

  CHANGE_BANK_RECEIPT_PAGE = '/bankbytte/fullfort',

  CREDIT_CARD_BECOME_CUSTOMER = '/kredittkort/bli-kunde',
  CREDIT_CARD_FORM = '/kredittkort/soknad',

  CREDIT_CARD_PLATINUM_BECOME_CUSTOMER = '/kredittkort/platinum/bli-kunde',
  CREDIT_CARD_PLATINUM_FORM = '/kredittkort/platinum/soknad',

  CREDIT_CARD_PLATINUM_PRODUCT_PAGE = '/kredittkort/platinum',
  CREDIT_CARD_PLATINUM_RECEIPT_PAGE = '/kredittkort/platinum/fullfort',
  // credit card
  CREDIT_CARD_PRODUCT_PAGE = '/kredittkort',
  CREDIT_CARD_RECEIPT_PAGE = '/kredittkort/fullfort',
  // edit credit card
  EDIT_CARD_NO_CARD = '/administrer-kredittkort/ingen-kort/',
  EDIT_CARD_TERMINATE_RECEIPT = '/administrer-kredittkort/avslutt-kredittkort/fullfort',
  EDIT_CREDIT_CARD = '/administrer-kredittkort',
  EDIT_CREDIT_LIMIT_PLATINUM_RECEIPT_PAGE = '/administrer-kredittkort/kredittgrense/platinum/fullfort',
  EDIT_CREDIT_LIMIT_RECEIPT_PAGE = '/administrer-kredittkort/kredittgrense/fullfort',
  // edit mortgage
  EDIT_MORTGAGE = '/boliglan',
  EDIT_MORTGAGE_BECOME_CUSTOMER = '/boliglan/bli-kunde',
  EDIT_MORTGAGE_RECEIPT_PAGE = '/boliglan/fullfort',
  // common pages
  ERROR = '/error',
  // certificate of goodness or customer declaration
  GOODNESS_CERTIFICATION_OR_CUSTOMER_DECLARATION = '/godhets-og-kundeerklaering',
  GOODNESS_CERTIFICATION_OR_CUSTOMER_DECLARATION_BECOME_CUSTOMER = '/godhets-og-kundeerklaering/bli-kunde',
  GOODNESS_CERTIFICATION_OR_CUSTOMER_DECLARATION_RECEIPT_PAGE = '/godhets-og-kundeerklaering/fullfort',
  // online bank
  ONLINE_BANK = '/bank',
  // online bank services for children
  ONLINE_BANK_CHILD = '/bank/barn',
  ONLINE_BANK_CHILD_ACCOUNT_RECEIPT_PAGE = '/bank/barn/konto-og-kort/fullfort',
  ONLINE_BANK_CHILD_BANKID_RECEIPT_PAGE = '/bank/barn/bankid/fullfort',
  ONLINE_BANK_CHILD_PUM_RECEIPT_PAGE = '/bank/barn/pum/fullfort',

  // online bank receipt page
  ONLINE_BANK_RECEIPT_PAGE = '/bank/fullfort',
}
